import { bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideRouter, withHashLocation } from '@angular/router';
import { importProvidersFrom } from '@angular/core';
import { provideTranslateService, provideTranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader, provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { ClipboardModule } from 'ngx-clipboard';
import { provideAuth, withAppInitializerAuthCheck } from 'angular-auth-oidc-client';

import { AppComponent } from './app/app.component';
import { routes } from './app/app.routes';
import { authenticationInterceptor } from './app/service/authentication/authentication-interceptor';
import { authErrorInterceptor } from './app/service/authentication/auth-error.interceptor';
import { buildAuthConfig } from './app/service/authentication/auth-config';
import { httpInterceptor } from './app/service/http-interceptor.service';
import { LanguageService } from './app/language/language.service';
import { SalesOrgService } from './app/service/salesOrg.service';
import { LoadingIndicatorService } from './app/loading-indicator/loading-indicator.service';
import { MessageService } from './app/service/message.service';
import { McsSearchService } from './app/service/mcs-search.service';
import { AdvancedUserService } from './app/service/advanced-user.service';

bootstrapApplication(AppComponent, {
  providers: [
    provideAnimations(),
    provideAuth({ config: buildAuthConfig() }, withAppInitializerAuthCheck()),
    provideHttpClient(withInterceptors([authenticationInterceptor, authErrorInterceptor, httpInterceptor])),
    provideRouter(routes, withHashLocation()),
    provideTranslateService({
      loader: provideTranslateLoader(TranslateHttpLoader)
    }),
    ...provideTranslateHttpLoader({ prefix: 'assets/i18n/', suffix: '.json' }),
    importProvidersFrom(
      ClipboardModule,
    ),
    LanguageService,
    SalesOrgService,
    LoadingIndicatorService,
    MessageService,
    McsSearchService,
    AdvancedUserService,
  ]
}).catch(err => console.error(err));


